import { useEffect, useState } from "react";
import { Loader2, Moon, Radio, Square } from "lucide-react";
import { api } from "@/lib/api";
import { recall, remember } from "@/lib/newsCache";

// After six: the two stories worth knowing before bed, in a calm voice.
export const EveningCard = ({ speaker, lang }) => {
  const said = lang || "en";
  const [card, setCard] = useState(() => recall(`evening:${said}`));
  const evening = new Date().getHours() >= 18;

  useEffect(() => {
    if (!evening) return;
    const kept = recall(`evening:${said}`);
    if (kept) return setCard(kept);
    api
      .get("/news/evening", { params: { lang: said } })
      .then(({ data }) => {
        if (!data.text) return;
        setCard(data);
        remember(`evening:${said}`, data);
      })
      .catch(() => {});
  }, [said, evening]);

  if (!evening || !card?.text) return null;
  const reading = speaker.playing === "evening";

  return (
    <div className="mt-3 rounded-3xl border border-white/10 bg-white/[0.03] p-5" data-testid="evening-card">
      <div className="flex flex-wrap items-center gap-2">
        <p className="flex items-center gap-2 text-[11px] font-semibold uppercase tracking-widest text-ink-soft">
          <Moon className="h-4 w-4 text-brand" /> Before bed
        </p>
        <button
          data-testid="evening-listen"
          onClick={() => speaker.play("evening", async () => card.text)}
          className="ms-auto inline-flex min-h-[30px] items-center gap-1.5 rounded-full border border-white/10 px-3 text-xs text-ink-soft transition-colors hover:border-brand/50 hover:text-brand"
        >
          {speaker.loading === "evening" ? <Loader2 className="h-3.5 w-3.5 animate-spin" />
            : reading ? <Square className="h-3.5 w-3.5 text-brand" />
            : <Radio className="h-3.5 w-3.5 text-brand" />}
          {reading ? "Stop" : "Read it to me"}
        </button>
      </div>

      <p className="mt-3 text-sm leading-relaxed" dir="auto" data-testid="evening-text">
        {card.text}
      </p>

      {card.stories?.length > 0 && (
        <ul className="mt-3 space-y-1.5">
          {card.stories.map((story) => (
            <li key={story.story_id} className="text-xs">
              <a href={story.url} target="_blank" rel="noreferrer" dir="auto"
                 data-testid={`evening-story-${story.story_id}`}
                 className="hover:text-brand">
                {story.title}
              </a>
              <span className="text-ink-soft">
                {story.source ? ` · ${story.source}` : ""}
                {story.read_min ? ` · ${story.read_min} min` : ""}
              </span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
